var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 16,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.864 0a4.95 4.95 0 00-4.338 2.584A4.54 4.54 0 0012.898.76 4.563 4.563 0 008.346 5.31c0 1.16.45 2.227 1.173 3.035H1.517C.691 8.346 0 9.036 0 9.863v5.311c0 .827.69 1.518 1.517 1.518h1.138v15.174c0 .827.691 1.517 1.518 1.517H29.21c.827 0 1.517-.69 1.517-1.517V16.692h1.139c.827 0 1.517-.691 1.517-1.518v-5.31c0-.828-.69-1.518-1.517-1.518H24.42a4.92 4.92 0 001.375-3.414A4.943 4.943 0 0020.864 0zm0 1.517a3.402 3.402 0 013.415 3.414 3.402 3.402 0 01-3.414 3.415H17.45V4.93a3.402 3.402 0 013.414-3.414zm-4.93 3.794a3.024 3.024 0 00-3.036-3.035 3.024 3.024 0 00-3.035 3.035 3.024 3.024 0 003.035 3.035h3.035V5.31zM1.517 9.863h11.38v5.31H1.518v-5.31zm17.45 0h-4.552v5.31h4.552v-5.31zm1.517 0h11.38v5.31h-11.38v-5.31zm-7.587 6.828H4.173v15.175h8.725V16.69zm1.518 0h4.552v15.175h-4.552V16.69zm14.794 0h-8.725v15.175h8.725V16.69z",
    fill: "#000"
  })));
}
export default SvgGift;